import Vue from 'vue';
import Vuex from 'vuex';

import { unnotificationsModule } from '@ulibs/unnotificationsqueue';
import { loginModule } from '@ulibs/unlogin/module';
import { RESET_ALL_STATE } from './initializeModule';
import { plugins } from './plugins';

Vue.use(Vuex);

const initialModules = {
  unnotifications: unnotificationsModule,
  login: loginModule,
};

export const store = new Vuex.Store({
  modules: initialModules,
  plugins,
  actions: {
    resetAllState({ commit }) {
      commit(RESET_ALL_STATE);
    }
  },
  strict: process.env.NODE_ENV !== 'production'
});
